import { selfAxios } from "../../../../../axios/selfAxios.js";
async function opGetMarketRightDetail(params) {
  const res = await selfAxios.get(`/ucenterapi/internal/business/marketRightDetail`, { params });
  return res.data;
}
export { opGetMarketRightDetail };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/internal/business/marketRightDetail/get.js